export default __webpack_public_path__ + "static/media/ingested-event.1bde0fcd.svg";